import { TMetaPrimitives } from '@cian/logger/shared';
import {
  fetchUpdateConfig,
  TUpdateConfigResponse,
  TUpdateConfigRequest,
} from 'shared/repositories/promotions-flow-control/v1/update-config';

import { IApplicationContext } from 'shared/types/applicationContext';

export type { TUpdateConfigRequest };

export async function updateProjectConfig(
  { logger, httpApi }: IApplicationContext,
  parameters: TUpdateConfigRequest,
): Promise<boolean> {
  try {
    const result: TUpdateConfigResponse = await fetchUpdateConfig({ httpApi, parameters });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/updateProjectConfig.ts [updateProjectConfig]',
        message: 'Не удалось обновить конфиг проекта',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/updateProjectConfig.ts [updateProjectConfig]',
      message: 'Не удалось обновить конфиг проекта',
    });

    throw error;
  }
}
